import React, { useContext, useState, useEffect } from 'react';

import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { contentContext } from "../../context/contentContext";
import tmdbApi from "../../api/tmdbApi";

let { appname, lambda } = window.app;

const CheckoutForm = ({ totalAmount, formData, validateForm }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [storeData, setStoreData] = useState([]);
  const useruniqueid = localStorage.getItem("clientid");
  const { userData, clientInfo, setClientInfo, setBusinessData } = useContext(contentContext);
  console.log("clientInfooooooooooooooooooooooooooooooooooooooooooooooo",clientInfo)
  useEffect(() => {
    getStore();
  }, []);


  const getStore = () => {
    const token = localStorage.getItem("token");
    axios({
      method: 'GET',
      url: `${lambda}/clientInfo?appname=${appname}&clientid=${useruniqueid}&token=${token}`,
    })
      .then(function (response) {
        if (response?.data?.result && response?.data?.result?.[0]) {
          setStoreData(response.data.result[0]);
          setClientInfo(response.data.result[0])
          setBusinessData(response.data.result[0])
        }
      });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    // ✅ Validate Billing Form First
    if (!validateForm()) {
      setLoading(false);
      return;
    }

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      console.error("❌ createPaymentMethod error:", error.message);
      setError(error.message);
      setLoading(false);
      setTimeout(function () { setError("") }, 3000);
      return;
    } else {
      // console.log("✅ Created payment method:", paymentMethod.id);
      // Send `paymentMethod.id` to backend
    }
    // console.log("paymentMethod.id", paymentMethod.id, paymentMethod);
    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    const clientid = localStorage.getItem('clientid');
    const token = localStorage.getItem('token');

    try {
      let payloadData = location?.state;


      let payload = {
        address: formData,
        planid: payloadData?.planid,
        planType: payloadData?.plantype,
        subscription: payloadData?.subscription,
        totalAmount: payloadData?.subscriptionPrice,
        paymentMethodId: paymentMethod.id,
      };

      localStorage.setItem('billingAddress', JSON.stringify(formData));
      const response = await axios.post(`${lambda}/payment?appname=${appname}&clientid=` + clientid, payload);
      const { result } = response.data;
      const clientSecret = typeof result === 'string' ? result : (result?.clientSecret || result?.ClientSecret);



      if (clientSecret) {
        stripe.confirmCardPayment(clientSecret).then(async ({ error: confirmError, paymentIntent }) => {
          if (confirmError) {
            setError(confirmError.message);
            setLoading(false);
            await axios.post(`${lambda}/update-transaction-status?appname=${appname}&clientsecret=` + clientSecret, {
              paymentIntentId: confirmError.payment_intent?.id,
              status: 'failed',
            });
            setTimeout(function () { setError("") }, 3000);
            return;
          }
           console.log('paymentIntent ', paymentIntent)
          if (paymentIntent.status === 'succeeded') {
           console.log('Payment succeeded!');

            await axios.post(`${lambda}/update-transaction-status?appname=${appname}&clientsecret=` + clientSecret, {
              paymentIntentId: paymentIntent.id,
              status: 'success',
            });

            toast.success("Payment Successful!", { position: "bottom-center" });
            setTimeout(() => {
              if (location?.state && location?.state?.subscriptionPrice !== clientInfo?.subscriptionPrice) {
                getStore()
                navigate("/upgradeplan")

              } else
                if (storeData?.setupStatus === false || storeData?.setupStatus === "false") {
                  getStore()
                  // First-time setup: payment succeeded, now the client must connect
                  // their bank account before they can add a store.
                  navigate("/connectbankaccount", { state: { nextRoute: "/addstore", mandatory: true } });

                } else {
                  getStore()
                  navigate(`/dashboard`);
                }
            }, 5000);

            // Show success message or redirect
          } else if (paymentIntent.status === 'requires_payment_method') {
            // console.log('Payment failed or incomplete.');
            // Optionally retry, or show failure UI
            setError(paymentIntent.status);
            setLoading(false);
            await axios.post(`${lambda}/update-transaction-status?appname=${appname}&clientsecret=` + clientSecret, {
              paymentIntentId: paymentIntent.id,
              status: 'failed',
            });
            setTimeout(function () { setError("") }, 3000);

          } else {
            // console.log('Payment in progress or in another state:', paymentIntent.status);
          }
        });
      }




    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement />
      <button className="fill-btn save_continue mt-3 w-100" type="submit" disabled={!stripe || loading}>
        {loading ? 'Processing...' : `Pay $${totalAmount}`}
      </button>
      {error && <div className="errormsg mt-2">{error}</div>}
    </form>
  );
};


const PaymentPage = () => {
  const { userData,clientInfo } = useContext(contentContext);
  const location = useLocation();
  const navigate = useNavigate();
  const totalAmount = location?.state?.subscriptionPrice;
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const publishKey = window?.site?.common?.stripe;
      if (publishKey) {
        setStripePromise(loadStripe(publishKey));
        clearInterval(interval);
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);
  let billingAddress = localStorage.getItem('billingAddress');
  if (billingAddress) billingAddress = JSON.parse(billingAddress);
  const [countries, setCountries] = useState('');
  const [loadingCountries, setLoadingCountries] = useState(true);

  // const [formData, setFormData] = useState({
  //   firstName: userData?.contactname || billingAddress?.firstName || userData?.name || "",
  //   lastName: "",
  //   email: userData?.emailId || billingAddress?.email || "",
  //   streetAddress1: "",
  //   streetAddress2: "",
  //   state: "",
  //   city: "",
  //   zipCode: "",
  //   phone: userData?.phone || "",
  //   billingSameAsShipping: billingAddress?.billingSameAsShipping || true,
  //   idc: userData?.idc || "IND",
  //   // shippingFirstName: billingAddress?.shippingFirstName || '',
  //   // shippingLastName: billingAddress?.shippingLastName || '',
  //   shippingStreetAddress1: billingAddress?.shippingStreetAddress1 || '',
  //   shippingStreetAddress2: billingAddress?.shippingStreetAddress2 || '',
  //   shippingCity: billingAddress?.shippingCity || '',
  //   shippingState: billingAddress?.shippingState || '',
  //   shippingZipCode: billingAddress?.shippingZipCode || '',
  //   shippingPhone: billingAddress?.shippingPhone || "",
  //   shippingIdc: billingAddress?.shippingIdc || "IND",
  // });
  const [formData, setFormData] = useState({
  firstName: userData?.contactname || billingAddress?.firstName || userData?.name || "",
  lastName: "",
  email: userData?.emailId || billingAddress?.email || "",
  streetAddress1: "",
  streetAddress2: "",
  state: "",
  city: "",
  zipCode: "",
  phone: userData?.phone || "",
  billingSameAsShipping: billingAddress?.billingSameAsShipping || true,
  idc: (userData?.idc || "IND").trim(), // Trim whitespace here
  shippingStreetAddress1: billingAddress?.shippingStreetAddress1 || '',
  shippingStreetAddress2: billingAddress?.shippingStreetAddress2 || '',
  shippingCity: billingAddress?.shippingCity || '',
  shippingState: billingAddress?.shippingState || '',
  shippingZipCode: billingAddress?.shippingZipCode || '',
  shippingPhone: billingAddress?.shippingPhone || "",
  shippingIdc: (billingAddress?.shippingIdc || "IND").trim(), // Trim whitespace here
});

  // Parse legacy full-address strings like "1060 Elkgrove Ave, Venice, CA 90291, USA"
  // into structured parts when individual fields weren't saved yet.
  const parseLegacyAddress = (fullAddress) => {
    if (!fullAddress) return {};
    const parts = fullAddress.split(', ');
    if (parts.length >= 3) {
      const street = parts[0];
      const city = parts[1];
      const stateZip = parts[2].split(' ');
      const state = stateZip[0] || '';
      const zip = stateZip[1] || '';
      return { street, city, state, zip };
    }
    return { street: fullAddress, city: '', state: '', zip: '' };
  };

  useEffect(() => {
    if (clientInfo && Object.keys(clientInfo).length > 0) {
      // Use structured fields if available, otherwise parse the full address string
      const hasStructured = clientInfo?.streetAddress || clientInfo?.state || clientInfo?.zipcode;
      const parsed = hasStructured ? {} : parseLegacyAddress(clientInfo?.businessaddress);

      setFormData(prev => ({
        ...prev,
        firstName: clientInfo?.contactname || prev.firstName,
        email: clientInfo?.emailId || prev.email,
        phone: clientInfo?.phone || prev.phone,
        idc: clientInfo?.idc?.trim() || prev.idc,
        streetAddress1: clientInfo?.streetAddress || parsed.street || prev.streetAddress1,
        city: clientInfo?.city || parsed.city || prev.city,
        state: clientInfo?.state || parsed.state || prev.state,
        zipCode: clientInfo?.zipcode || parsed.zip || prev.zipCode,
      }));
    }
  }, [clientInfo]);


  const GetCountries = async () => {
    try {
      const response = await tmdbApi.getLookUp({
        type: ["country"],
        sortBy: "alpha3",
      });

      let tmp = response?.result?.data || [];

      // Sort alphabetically by country name
      tmp = tmp.sort((a, b) => a?.alpha3?.localeCompare(b?.alpha3));

      setCountries(tmp);
      setLoadingCountries(false);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setLoadingCountries(false);
    }
  };


  const handleCountryChange = (e) => {
    const newCountry = e.target.value;
    setFormData((prev) => ({
      ...prev,
      idc: newCountry,
      phone: "", // Reset phone number when country changes
    }));
  };

  const [formErrors, setFormErrors] = useState({});

  const validateForm = () => {
    const errors = {};

    if (!formData.firstName.trim()) errors.firstName = "First Name is required.";
    // if (!formData.lastName.trim()) errors.lastName = "Last Name is required.";
    if (!formData.email.trim()) {
      errors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Invalid email format.";
    }
    if (!formData.streetAddress1.trim()) errors.streetAddress1 = "Street Address is required.";
    if (!formData.state.trim()) errors.state = "State is required.";
    if (!formData.city.trim()) errors.city = "City is required.";
    if (!formData.zipCode.trim()) {
      errors.zipCode = "Zip Code cannot be empty.";
    } else if (!/^\d{5,6}$/.test(formData.zipCode.trim())) {
      errors.zipCode = "Zip Code must be 5 or 6 digits.";
    }

    const phone = formData?.phone?.trim();
    const idc = formData?.idc?.trim();
    if (!phone) {
      errors.phone = "Enter phone number"
    } else if (
      (idc === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) ||
      (idc === "IND" && !/^\d{5}-\d{5}$/.test(phone))
    ) {
      errors.phone = "Invalid phone number format";
    }

    if (!formData.billingSameAsShipping) {

      if (!formData.shippingStreetAddress1.trim()) errors.shippingStreetAddress1 = "Shipping Address is required.";
      if (!formData.shippingState.trim()) errors.shippingState = "Shipping State is required.";
      if (!formData.shippingCity.trim()) errors.shippingCity = "Shipping City is required.";
      if (!formData.shippingZipCode.trim()) {
        errors.shippingZipCode = "Shipping Zip Code cannot be empty.";
      } else if (!/^\d{5,6}$/.test(formData.shippingZipCode.trim())) {
        errors.shippingZipCode = "Shipping Zip Code must be 5 or 6 digits.";
      }


      const shippingPhone = formData?.shippingPhone?.trim();
      const shippingIdc = formData?.shippingIdc?.trim();
      if (!shippingPhone) {
        errors.shippingPhone = "Enter phone number"
      } else if (
        (shippingIdc === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(shippingPhone)) ||
        (shippingIdc === "IND" && !/^\d{5}-\d{5}$/.test(shippingPhone))
      ) {
        errors.shippingPhone = "Invalid phone number format";
      }

    }



    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleInputChange = (e) => {

    const { name, value, type, checked } = e.target;
    let errorsTmp = { ...formErrors };
    errorsTmp[name] = ''
    setFormErrors(errorsTmp);
    if (name === "zipCode") {
      const numericValue = value.replace(/\D/g, ""); // remove non-digit characters
      setFormData({ ...formData, [name]: numericValue });
    } else if (name === "phone") {

      let formattedValue = value;
      let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
      const currentIdc = formData?.idc?.trim(); // Remove unnecessary spaces

      if (currentIdc === "USA") {
        // console.log("Using USA Format");
        if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
        if (numericValue.length > 6) {
          formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
        } else if (numericValue.length > 3) {
          formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
        } else {
          formattedValue = numericValue;
        }
      } else if (currentIdc === "IND") {
        // console.log("Using India Format");
        if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
        if (numericValue.length > 5) {
          formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
        } else {
          formattedValue = numericValue;
        }
      }

      // Update the phone number only
      setFormData(prev => ({ ...prev, phone: formattedValue }));
      return; // Stop further execution for "phone" field

    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
    // Optional: live validation on input
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    if (!formData.billingSameAsShipping) {
      setFormData((prev) => ({
        ...prev,
        // shippingFirstName: prev.firstName,
        // shippingLastName: prev.lastName,
        // shippingEmail: prev.email,
        shippingStreetAddress1: prev.streetAddress1,
        shippingStreetAddress2: prev.streetAddress2,
        shippingCity: prev.city,
        shippingState: prev.state,
        shippingZipCode: prev.zipCode,
        shippingPhone: prev.phone,
        shippingIdc: prev.idc,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        shippingFirstName: "",
        shippingLastName: "",
        shippingEmail: "",
        shippingStreetAddress1: "",
        shippingStreetAddress2: "",
        shippingCity: "",
        shippingState: "",
        shippingZipCode: "",
        shippingPhone: "",
        shippingIdc: "",
      }));
    }
  }, [formData.billingSameAsShipping]);

  const closePayment = () => {
    navigate(-1)
  }
  useEffect(() => {
    GetCountries();
  }, []);
  return (
    <div id="page-top">
      <ToastContainer position="bottom-right" id="toastContainer" />
      <div className="container signin-wrapper payment-wrapper" id="innerBodyPayment">
        <div className="logo_section pt-3 px-3">
          <img src="https://d13pnvf7i9kk1t.cloudfront.net/spotsaverStaging/images/web/logo-dark.png" className="logo" />
          <button className="close-btn" onClick={closePayment} id="payment-close-button"><span className="material-icons">close</span></button>
        </div>
        {/* Payment Section */}
        <div className="inner-wrapper mt-0" id="innerWrapper">

          <div className="billing_address mt-4 mb-3" id="billingAddress">
            <div className="card" id="billingCard">
              <div className="card-body" id="billingCardBody">
                <h4 id="billingTitle">Billing Address</h4>
                <div className="row" id="billingFormRow">
                  <div className="col-md-6" id="firstNameCol">
                    <div className="form-group" id="firstNameGroup">
                      <label htmlFor="firstName">First Name</label>
                      <input
                        id="firstName"
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        placeholder="Enter First Name"
                        className="form-control"
                      />                      {formErrors.firstName && <small className="errormsg">{formErrors.firstName}</small>}

                    </div>
                  </div>
                  <div className="col-md-6" id="lastNameCol">
                    <div className="form-group" id="lastNameGroup">
                      <label htmlFor="lastName">Last Name</label>
                      <input
                        id="lastName"
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        placeholder="Enter Last Name"
                        className="form-control"
                      />                      {formErrors.lastName && <small className="errormsg">{formErrors.lastName}</small>}

                    </div>
                  </div>
                  <div className="col-md-12" id="emailCol">
                    <div className="form-group" id="emailGroup">
                      <label htmlFor="email">Email Address</label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Enter Email Address"
                        className="form-control"
                      />                      {formErrors.email && <small className="errormsg">{formErrors.email}</small>}

                    </div>
                  </div>
                  <div className="col-md-12" id="streetAddressCol">
                    <div className="form-group" id="streetAddress1Group">
                      <label htmlFor="streetAddress1">Street Address</label>
                      <input
                        id="streetAddress1"
                        type="text"
                        name="streetAddress1"
                        value={formData.streetAddress1}
                        onChange={handleInputChange}
                        placeholder="Enter Street Address 1"
                        className="form-control"
                      />                      {formErrors.streetAddress1 && <small className="errormsg">{formErrors.streetAddress1}</small>}

                    </div>
                  </div>
                  <div className="col-md-12" id="streetAddressCol">
                    <div className="form-group" id="streetAddress2Group">
                      <label htmlFor="streetAddress1">Street Address2</label>
                      <input
                        id="streetAddress2"
                        type="text"
                        name="streetAddress2"
                        value={formData.streetAddress2}
                        onChange={handleInputChange}
                        placeholder="Enter Street Address 2"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6" id="stateCol">
                    <div className="form-group" id="stateGroup">
                      <label htmlFor="state">State/Province</label>
                      <input
                        id="state"
                        type="text"
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        placeholder="Enter State/Province"
                        className="form-control"
                      />                      {formErrors.state && <small className="errormsg">{formErrors.state}</small>}

                    </div>
                  </div>
                  <div className="col-md-6" id="cityCol">
                    <div className="form-group" id="cityGroup">
                      <label htmlFor="city">City</label>
                      <input
                        id="city"
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        placeholder="Enter City"
                        className="form-control"
                      />                      {formErrors.city && <small className="errormsg">{formErrors.city}</small>}

                    </div>
                  </div>
                  <div className="col-md-6" id="zipCodeCol">
                    <div className="form-group" id="zipCodeGroup">
                      <label htmlFor="zipCode">Zip/Postal Code</label>
                      <input
                        id="zipCode"
                        type="text"
                        name="zipCode"
                        value={formData.zipCode}
                        onChange={handleInputChange}
                        placeholder="Enter Zip/Postal Code"
                        className="form-control"
                        maxLength={6}
                      />                      {formErrors.zipCode && <small className="errormsg">{formErrors.zipCode}</small>}

                    </div>
                  </div>


                  <div className="col-md-6"></div>


                  <div className="col-md-12" id="stateCol">
                    <div className="form-group" id="stateGroup">
                      <label for="state">State/Province</label>
                      <div className="input-group mr-sm-2" id="phone-group">

                        <select
                          id="country-codel"
                          name="idc"
                          value={formData?.idc}
                          className="colorselect capitalize border-style"
                          onChange={(e) => handleCountryChange(e)}
                        >
                          {countries?.length > 0 &&
                            countries.map((task, i) => (
                              <option key={i} value={(task.alpha3).trim()}>
                                {task.alpha3} {task.countrycode}
                              </option>
                            ))}
                        </select>
                        <input id="contact-number" className="form-control contact-number" type="tel" name="phone" value={formData?.phone} placeholder="Enter Phone Number" onChange={handleInputChange} />
                      </div>
                      {formErrors.phone && <span id="phone-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{formErrors.phone}</span>}
                    </div>
                  </div>



                  <div className="col-md-12" id="billingSameAsShippingCol">
                    <div className="form-group" id="billingSameAsShippingGroup">
                      <div className="form-check">
                        <input
                          id="flexCheckDefault"
                          className="form-check-input"
                          type="checkbox"
                          name="billingSameAsShipping"
                          checked={formData.billingSameAsShipping}
                          onChange={handleInputChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          My billing and shipping address are the same
                        </label>
                      </div>
                    </div>
                  </div>

                  {!formData.billingSameAsShipping && (
                    <div className="shipping_address mt-4 mb-3" id="shippingAddress">
                      <div className="card" id="shippingCard">
                        <div className="card-body" id="shippingCardBody">
                          <h4 id="shippingTitle">Shipping Address</h4>
                          <div className="row" id="shippingFormRow">


                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor="shippingStreetAddress1">Street Address</label>
                                <input
                                  id="shippingStreetAddress1"
                                  type="text"
                                  name="shippingStreetAddress1"
                                  value={formData.shippingStreetAddress1}
                                  onChange={handleInputChange}
                                  placeholder="Enter Street Address 1"
                                  className="form-control"
                                />
                                {formErrors.shippingStreetAddress1 && (
                                  <small className="errormsg">{formErrors.shippingStreetAddress1}</small>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor="shippingStreet2">Street Address 2</label>
                                <input
                                  id="shippingStreetAddress2"
                                  type="text"
                                  name="shippingStreetAddress2"
                                  value={formData.shippingStreetAddress2}
                                  onChange={handleInputChange}
                                  placeholder="Enter Street Address 2"
                                  className="form-control"
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="shippingState">State/Province</label>
                                <input
                                  id="shippingState"
                                  type="text"
                                  name="shippingState"
                                  value={formData.shippingState}
                                  onChange={handleInputChange}
                                  placeholder="Enter State/Province"
                                  className="form-control"
                                />
                                {formErrors.shippingState && (
                                  <small className="errormsg">{formErrors.shippingState}</small>
                                )}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="shippingCity">City</label>
                                <input
                                  id="shippingCity"
                                  type="text"
                                  name="shippingCity"
                                  value={formData.shippingCity}
                                  onChange={handleInputChange}
                                  placeholder="Enter City"
                                  className="form-control"
                                />
                                {formErrors.shippingCity && (
                                  <small className="errormsg">{formErrors.shippingCity}</small>
                                )}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="shippingZip">Zip/Postal Code</label>
                                <input
                                  id="shippingZipCode"
                                  type="text"
                                  name="shippingZipCode"
                                  value={formData.shippingZipCode}
                                  onChange={handleInputChange}
                                  placeholder="Enter Zip/Postal Code"
                                  className="form-control"
                                  maxLength={6}
                                />
                                {formErrors.shippingZipCode && (
                                  <small className="errormsg">{formErrors.shippingZipCode}</small>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor="shippingPhone">Contact Number</label>
                                <div className="input-group mr-sm-2">
                                  <select
                                    id="shippingCountryCode"
                                    name="shippingIdc"
                                    className="colorselect capitalize border-style"
                                    value={formData.shippingIdc}
                                    onChange={handleInputChange}
                                  >
                                    {countries &&
                                      countries.map((task, i) => (
                                        <option key={i} value={task.alpha3}>
                                          {task.alpha3}
                                          {task.countrycode}
                                        </option>
                                      ))}
                                  </select>
                                  <input
                                    id="shippingPhone"
                                    className="form-control contact-number"
                                    type="tel"
                                    name="shippingPhone"
                                    value={formData.shippingPhone}
                                    onChange={handleInputChange}
                                    placeholder="Enter Phone Number"
                                  />
                                </div>
                                {formErrors.shippingPhone && (
                                  <span
                                    className="errormsg"
                                    style={{ fontWeight: "bold", color: "red" }}
                                  >
                                    {formErrors.shippingPhone}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="billing_summary mt-4 mb-3" id="billingSummary">
            <div className="card" id="billingSummaryCard">
              <div className="card-body" id="billingSummaryCardBody">
                <h4 id="billingSummaryTitle">Billing Summary</h4>
                <div className="total" id="totalAmountSection">
                  <p>Total</p>
                  <p id="totalAmount">{`$ ${totalAmount}`}</p>
                </div>
              </div>
            </div>
            <h4 className="mt-4" id="paymentMethodTitle">Payment Method</h4>
            <div className="card payment_method" id="paymentMethodCard">
              <div className="card-body" id="paymentMethodCardBody">
                <div className="d-flex align-items-center justify-content-between mb-3" id="paymentMethodHeader">
                  <p>Pay with Credit Card</p>
                  <img src="https://d1yfmfkyn2ebhw.cloudfront.net/images/app/images/credit-card.png" alt="Logo" id="creditCardLogo" />
                </div>
                <Elements stripe={stripePromise} id="creditCardNumberInput">
                  <CheckoutForm totalAmount={totalAmount} formData={formData} validateForm={validateForm} />
                </Elements>
              </div>
            </div>
            <p className="bank_security" id="bankSecurityMessage">
              <span className="material-icons">lock</span> We protect your payment information using encryption to provide bank-level security.
            </p>
          </div>
        </div>
      </div>
      {/* Footer section */}
      <footer className="login_footer" id="loginFooter">
        <div className="container-fluid">
          <p className="footer-para" id="footerText">© {new Date().getFullYear()} SpotSaver. All rights reserved.</p>
        </div>
      </footer>
    </div >

  );
};


export default PaymentPage;